import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import { CertID } from "./cert_id";
import { Extension } from "@peculiar/asn1-x509";
import { CertStatus } from "./cert_status";
export class SingleResponse {
    constructor(params = {}) {
        this.certID = new CertID();
        this.certStatus = new CertStatus();
        this.thisUpdate = new Date();
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: CertID })
], SingleResponse.prototype, "certID", void 0);
__decorate([
    AsnProp({ type: CertStatus })
], SingleResponse.prototype, "certStatus", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.GeneralizedTime })
], SingleResponse.prototype, "thisUpdate", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.GeneralizedTime, context: 0, optional: true })
], SingleResponse.prototype, "nextUpdate", void 0);
__decorate([
    AsnProp({ type: Extension, context: 1, repeated: "sequence", optional: true })
], SingleResponse.prototype, "singleExtensions", void 0);
